import cx from "classnames";
import { object, string } from "prop-types";
import Icon from "../Icon/Icon.jsx";

const propTypes = {
  cardEyebrow: string,
  disabledLegend: string,
  exemplarsTitle: string,
  exploreTopicTitle: string,
  topic: object,
};

const TopicCard = (props) => {
  const { cardEyebrow, disabledLegend, exemplarsTitle, topic } = props;
  const { exemplars, icon, links, summary, title } = topic;

  return (
    <div className="explore-topics__card">
      <div className="explore-topics__card-info">
        <div className="explore-topics__card-icon">
          {icon && <img src={icon} alt={`${title} icon`} />}
        </div>
        <div className="explore-topics__card-header">
          {cardEyebrow && (
            <p className="explore-topics__card-eyebrow title--eyebrow">
              {cardEyebrow}
            </p>
          )}
          <h3 className="explore-topics__card-title h1">{title}</h3>
        </div>
        <div className="explore-topics__card-body container container--70-30">
          <div className="container__col">
            {summary && (
              <p className="explore-topics__card-summary">{summary}</p>
            )}
            {links && (
              <div className="explore-topics__card-links">
                <h4 className="explore-topics__card-links-title h5">{`${title} 101`}</h4>

                <section className="narrative-links narrative-links--big">
                  <div className={cx("narrative-links__primary-nav")}>
                    <nav aria-label="section links">
                      <ul>
                        {links &&
                          links.map((link, index) => (
                            <li key={index + link.text}>
                              <a
                                className={cx(
                                  "narrative-links__primary-link arrow-link",
                                  {
                                    "narrative-links__primary-link--active":
                                      link.isActive,
                                  },
                                )}
                                href={link.url}
                              >
                                {link.text}
                              </a>
                            </li>
                          ))}
                      </ul>
                    </nav>
                  </div>
                </section>
              </div>
            )}
          </div>

          <div className="container__col">
            {exemplars && (
              <div className="explore-topics__card-links">
                <h4 className="explore-topics__card-links-title h5">
                  {exemplarsTitle}
                </h4>

                <nav aria-label="section links">
                  <ul className="explore-topics__links">
                    {exemplars.map((link, index) => (
                      <div
                        key={index + link.text}
                        className={cx("narrative-explore-further__exemplar", {
                          "narrative-explore-further__exemplar--disabled": !link.isActive,
                        })}
                      >
                        <a
                          href={link.url}
                          className={cx(
                            "narrative-explore-further__exemplar-link",
                            {
                              "arrow-link": link.isActive,
                            },
                          )}
                        >
                          {link.icon && (
                            <Icon
                              className="narrative-explore-further__country-icon icon--24x24"
                              countryCode={link.icon}
                            />
                          )}
                          <span className="narrative-explore-further__exemplar-name">
                            {link.text}
                          </span>
                          {!link.isActive && (
                            <span className="narrative-explore-further__disabled-text">
                              {disabledLegend}
                            </span>
                          )}
                        </a>
                      </div>
                    ))}
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

TopicCard.propTypes = propTypes;
export default TopicCard;
